const railTickets = ['Start','Retailer Info','Complete']

export default {
  none : ['none'],
  standard : ['Start','Images','Colours','Complete'],
  
  D01 : railTickets,
  D04 : railTickets,
  D10 : railTickets,
  D11 : railTickets,
  D13 : railTickets,
    
  smartix_business : ['Start','Title', 'Images', 'Colours', 'Contact Details', 'Create VCF file','Complete'],
  smartix_event : ['Start','Images','Colours','Ticket Config','Complete'],
  smartix_event_bg : ['Start','Images','Colours','Ticket Config','Complete'],
  smartix_stamp : ['Start','Logos','Stamp Images','Colours','Stamp Config','Stamp Complete'],
  smartix_loyalty : ['Start','Logos','Colours','Loyalty Config','Loyalty Complete'],
  smartix_gift : ['Start','Logos','Colours','Gift Config','Complete'],
}